import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface GenericNotesDialogData {
  title?: string;
  message?: string;
  notes?: string;
  requireNotes?: boolean;
}

export interface GenericNotesDialogResult {
  notes: string;
}

@Component({
  selector: 'app-generic-notes-dialog',
  template: `
    <h2 mat-dialog-title>{{ title }}</h2>
    <mat-dialog-content>
      <p class="task-popup-message" *ngIf="message">{{ message }}</p>
      <mat-form-field appearance="fill" class="task-popup-field">
        <mat-label>NOTES</mat-label>
        <textarea matInput rows="5" [(ngModel)]="notes"></textarea>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="skip()">SKIP</button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="requireNotes && !notes.trim()"
        (click)="save()"
      >
        SAVE
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .task-popup-message {
        margin: 0 0 12px;
        font-size: 13px;
        line-height: 1.4;
      }
      .task-popup-field {
        width: 100%;
      }
    `,
  ],
})
export class GenericNotesDialogComponent {
  title: string;
  message: string;
  notes = '';
  requireNotes = false;

  constructor(
    public dialogRef: MatDialogRef<
      GenericNotesDialogComponent,
      GenericNotesDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: GenericNotesDialogData
  ) {
    this.title = data?.title || 'NOTES';
    this.message = data?.message || '';
    this.notes = String(data?.notes || '');
    this.requireNotes = !!data?.requireNotes;
  }

  skip(): void {
    this.dialogRef.close({ notes: '' });
  }

  save(): void {
    const notes = this.notes.trim();
    if (this.requireNotes && !notes) {
      return;
    }
    this.dialogRef.close({ notes });
  }
}
